module.exports = __webpack_public_path__ + "assets/img/img81.df6a08fe.png";